/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TeamsConnectionStatus,
    TeamsConnectionStatusFromJSON,
    TeamsConnectionStatusFromJSONTyped,
    TeamsConnectionStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface TeamsConnection
 */
export interface TeamsConnection {
    /**
     * 
     * @type {number}
     * @memberof TeamsConnection
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TeamsConnection
     */
    name: string;
    /**
     * 
     * @type {TeamsConnectionStatus}
     * @memberof TeamsConnection
     */
    status: TeamsConnectionStatus;
}

export function TeamsConnectionFromJSON(json: any): TeamsConnection {
    return TeamsConnectionFromJSONTyped(json, false);
}

export function TeamsConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamsConnection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'status': TeamsConnectionStatusFromJSON(json['status']),
    };
}

export function TeamsConnectionToJSON(value?: TeamsConnection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'status': TeamsConnectionStatusToJSON(value.status),
    };
}


